import { OrderWithEvents } from '../../types/orders';
import { AccountAdminUser } from '../../types/management-auth';

export enum ActionTypes {
    GetOrder = '[order] GET_ORDER',
    OrderResponse = '[order] FETCH_ORDER_RESPONSE',
    OrderNotFoundResponse = '[order] ORDER_NOT_FOUND',
    CreateComment = '[order] CREATE_COMMENT',
    CreateCommentResponse = '[order] CREATE_COMMENT_RESPONSE',
    DeleteComment = '[order] DELETE_COMMENT',
    DeleteCommentResponse = '[order] DELETE_COMMENT_RESPONSE',
    GetUsers = '[order] GET_USERS',
    FetchUsersResponse = '[order] FETCH_USERS_RESPONSE',
}

export interface GetOrder {
    type: ActionTypes.GetOrder;
    payload: {
        accountId: string;
        orderId: string;
    };
}

export interface OrderResponse {
    type: ActionTypes.OrderResponse;
    payload: {
        order: OrderWithEvents;
    };
    meta: {
        cause: GetOrder;
    };
}

export interface CreateComment {
    type: ActionTypes.CreateComment;
    payload: {
        accountId: string;
        orderId: string;
        requestBody: {
            body: string;
        };
    };
}

export interface CreateCommentResponse {
    type: ActionTypes.CreateCommentResponse;
    payload: {
        order: OrderWithEvents;
    };
    meta: {
        cause: CreateComment;
    };
}

export interface DeleteComment {
    type: ActionTypes.DeleteComment;
    payload: {
        accountId: string;
        orderId: string;
        commentId: string;
    };
}

export interface DeleteCommentResponse {
    type: ActionTypes.DeleteCommentResponse;
    payload: {
        order: OrderWithEvents;
    };
    meta: {
        cause: DeleteComment;
    };
}

export interface OrderNotFoundResponse {
    type: ActionTypes.OrderNotFoundResponse;
    meta: {
        cause: GetOrder;
    };
}

export interface GetUsers {
    type: ActionTypes.GetUsers;
    payload: {
        accountId: string;
    };
}

export interface FetchUsersResponse {
    type: ActionTypes.FetchUsersResponse;
    payload: {
        users: AccountAdminUser[];
    };
    meta: {
        cause: GetUsers;
    };
}

export function getOrder(accountId: string, orderId: string): GetOrder {
    return {
        type: ActionTypes.GetOrder,
        payload: {
            orderId,
            accountId,
        },
    };
}

export function createComment(accountId: string, orderId: string, requestBody: {body: string}): CreateComment {
    return {
        type: ActionTypes.CreateComment,
        payload: {
            accountId,
            orderId,
            requestBody,
        },
    };
}
export function deleteComment(accountId: string, orderId: string, commentId: string): DeleteComment {
    return {
        type: ActionTypes.DeleteComment,
        payload: {
            accountId,
            orderId,
            commentId,
        },
    };
}

export function getUsers(accountId: string): GetUsers {
    return {
        type: ActionTypes.GetUsers,
        payload: {
            accountId,
        },
    };
}

export type Actions = GetOrder | OrderResponse | OrderNotFoundResponse | CreateComment | CreateCommentResponse | DeleteComment | DeleteCommentResponse | GetUsers | FetchUsersResponse;
